module.exports = __webpack_public_path__ + "img/renewp_logo.a1c2ae03.png";